import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import { UserDataService, UserSessionService } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';
import { DataLayer } from '../../common/datalayer/datalayer';
import { TodaysTrip } from '../../model/today-trip.model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { TodaysTripAwsService } from '../../services/mydelta-trip-service/trip-aws.service';
import { TripService } from '../../services/mydelta-trip-service/trip.service';
import { ErrorMessagesReducerStoreService } from '../../store/services/error-message.reducer.service';

@Component({
  selector: 'ngc-flyout-today',
  templateUrl: './flyout-today.component.html'
})
export class FlyoutTodayComponent implements OnInit, OnDestroy {
  @ViewChild('iropmsg') iropmsg: ElementRef;
  @ViewChild('fly') flyoutsection: ElementRef;
  @Input() resTodayTripContent: any;
  @Input() aemErrorMessages: any;
  @Input() mytripHeaderContentLabel: any;
  @Input() bookingHeaderContentLabel: any;
  @Input() medallionArrayFromContent: any;
  @Input() isDelta: any;
  @Input() showNewFlyout: any;
  @Input() showNewToday: any;
  @Input() iropEnabled: boolean;
  public resTodayTrip: any;
  public resAcctSumDetails: any;
  public fareBasisCode: string;
  public skymilesNbr: any;
  public noUpcomingTripContent: any;
  public seatNumber;
  gateNumber: any;
  public viewBoardingPass: boolean;
  public showIropModel: boolean;
  public hideIROPClose: boolean;
  public hrefURL: any;
  public iropErrorMessage: any;
  public iropErrorMsg: any;
  public iropErrorResp: any;
  public flightNumber: any;
  public iropClass: any;
  public getMemberDesc: any;
  public todaysTripForm: any;
  public formActionflight = '/mytrips/findPnr.action';
  public checkInSubmitNewUrl = '/PCCOciWeb/app/index.html';
  aemErrorResp: any;
  aemErrorMsgDetails: any;
  disableViewLink: boolean;
  spinner = false;
  formAction: string = null;
  accountSummaryServiceSubscribe: Subscription;
  todayTripServiceTripDetailsSubscribe: Subscription;
  @ViewChild('flyoutTodayMytripsForm') flyoutTodayMytripsForm: ElementRef;
  private unsubscribe: Subject<void> = new Subject();
  awsFlag = false;

  constructor(
    public bsModalRef: BsModalRef,
    private _el: ElementRef,
    private todayTripService: TripService,
    private accountSummaryService: AccountSummaryService,
    private errorService: ErrorMessagesReducerStoreService,
    private modalService: BsModalService,
    private renderer: Renderer2,
    private cdf: ChangeDetectorRef,
    private datalayer: DataLayer,
    private userSession: UserSessionService,
    private loggingService: LoggingService,
    private userDataService: UserDataService,
    private todaysTripAwsService: TodaysTripAwsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.hrefURL = window.location.origin;
    this.hideIROPClose = false;
    this.disableViewLink = false;
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.userSession.getServiceWorkerCheck()) {
        this.accountSummaryServiceSubscribe = this.getAccountSummary();
      }
    }
  }

  getAccountSummary() {
    return forkJoin([
      this.accountSummaryService.getAccountSummaryDetails(),
      this.userDataService.getAuthConfigContent()
    ])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        ([res, authConfig]) => {
          this.spinner = true;
          const errorContainer = document.querySelector(
            '.tab-container>.tab-content'
          );
          this.resAcctSumDetails = res;
          if (
            this.resAcctSumDetails !== null &&
            this.resAcctSumDetails !== undefined
          ) {
            /* if (this.resAcctSumDetails.membershipLevel === 'FF') {
           if (this.resTodayTripContent !== null && this.resTodayTripContent !== undefined) {
             this.getMemberDesc = this.resTodayTripContent.skymilesMember;
           }
         } else {
           this.getMemberDesc = this.resAcctSumDetails.medallionMemberDesc + '\u00AE';
         }*/
            this.getMemberDesc = this.getMedallionLabelFromContent(
              this.resAcctSumDetails.membershipLevel
            );
            this.datalayer.setDdcfbData(this.resAcctSumDetails);
          }
          this.skymilesNbr = this.resAcctSumDetails.smNumber;
          this.spinner = true;
          this.awsFlag = !!authConfig?.TRIPS_API_AWS;
          if (!this.iropEnabled) {
            this.todayTripServiceTripDetailsSubscribe =
              authConfig?.TRIPS_API_AWS
                ? this.todaysTripAwsService
                    .getTodayTrip(this.skymilesNbr)
                    .pipe(takeUntil(this.unsubscribe))
                    .subscribe(
                      (data) => this.processTodaysTripData(data),
                      (err) => {
                        if (err) {
                          this.aemErrorMsgDetails = this.aemErrorMessages
                            ? this.aemErrorMessages.get('TDY_SYS_ERR')
                            : 'TDY_SYS_ERR';
                          this.removeMargin();
                        }
                        this.spinner = false;
                      }
                    )
                : this.todayTripService
                    .getTripDetailsDetails(this.skymilesNbr)
                    .pipe(takeUntil(this.unsubscribe))
                    .subscribe(
                      (data) => this.processTodaysTripData(data),
                      (err) => {
                        if (err) {
                          this.aemErrorMsgDetails = this.aemErrorMessages
                            ? this.aemErrorMessages.get('TDY_SYS_ERR')
                            : 'TDY_SYS_ERR';
                          this.removeMargin();
                        }
                        this.spinner = false;
                      }
                    );
          } else {
            this.aemErrorMsgDetails =
              this.aemErrorMessages.get('TDY_IROP_ERROR');
            this.removeMargin();
            this.spinner = false;
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
          this.spinner = false;
        }
      );
  }

  processTodaysTripData = (data: TodaysTrip) => {
    this.resTodayTrip = data.trip;
    if (
      data.errors !== null &&
      data.errors !== undefined &&
      data.errors.length === 0
    ) {
      if (this.resTodayTrip !== null && this.resTodayTrip !== '') {
        this.resTodayTrip.viewTripDetails =
          this.resTodayTrip.viewTripDetails !== null
            ? this.resTodayTrip.viewTripDetails
            : '#';
        if (this.resTodayTrip.viewTripDetails === '#') {
          this.disableViewLink = true;
        }
        this.fareBasisCode = this.resTodayTrip.fareBasisCode || '';
        if (this.resTodayTrip.iropImpact || this.resTodayTrip.iropClean) {
          this.showIropModel = true;
          this.flightNumber = this.resTodayTrip.optFlightNumber;
          if (
            this.resTodayTrip.findOtherFlights !== null &&
            this.resTodayTrip.findOtherFlights !== undefined
          ) {
            this.formAction = this.resTodayTrip.findOtherFlights;
          }
          this.iropErrorResp = data;
          this.iropErrorMsg = this.aemErrorMessages
            ? this.aemErrorMessages.get(this.resTodayTrip.iropMessage)
            : this.resTodayTrip.iropMessage;
          if (
            this.iropErrorMsg &&
            typeof this.iropErrorMsg.errorMessageTitle !== 'undefined' &&
            this.iropErrorMsg.errorMessageTitle.indexOf('{{flightNumber}}') > -1
          ) {
            this.iropErrorMsg.errorMessageTitle =
              this.iropErrorMsg.errorMessageTitle.replace(
                '{{flightNumber}}',
                this.resTodayTrip.mktCarrierCode +
                  ' ' +
                  this.resTodayTrip.mktFlightNumber
              );
          }
        }
      } else {
        this.noUpcomingTripContent =
          this.todayTripService.getNoUpcomingTripContent();
        this.aemErrorMsgDetails = this.aemErrorMessages
          ? this.aemErrorMessages.get('NO_TRIPS_AVAIL')
          : 'NO_TRIPS_AVAIL';
        this.removeMargin();
      }
    } else {
      this.aemErrorMsgDetails = this.aemErrorMessages
        ? this.aemErrorMessages.get('TDY_SYS_ERR')
        : 'TDY_SYS_ERR';
      this.removeMargin();
    }
    this.spinner = false;
  };

  onSubmit(e: any): void {
    if (this.formAction !== null && this.formAction !== undefined) {
      e.preventDefault();
      e.target.submit();
    }
  }

  findAlternateFlight = (): void => {
    const cacheKey = uuid();
    sessionStorage.setItem(
      'search_request',
      JSON.stringify({
        inputvalue: this.resTodayTrip.recordLocator,
        firstName: this.resTodayTrip.firstName,
        lastName: this.resTodayTrip.lastName,
        tab: 'confirmationNo'
      })
    );
    sessionStorage.setItem(
      `postData-${cacheKey}`,
      JSON.stringify({
        recordLocator: this.resTodayTrip.recordLocator,
        firstName: this.resTodayTrip.firstName,
        lastName: this.resTodayTrip.lastName,
        fareBasisCode: this.fareBasisCode
      })
    );
    const openNewTab =
      this.resTodayTripContent?.findAlternateOpenNewTab === 'true'
        ? '_blank'
        : '_self';

    window.open(
      `${this.resTodayTrip.findOtherFlights}?cacheKeySuffix=${cacheKey}`,
      openNewTab
    );
  };

  mytripsTodayClick(e: any): void {
    this.userDataService.getAuthConfigContent().subscribe((response) => {
      if (response?.NEXT_GEN_MY_TRIPS) {
        if (
          this.resTodayTrip?.recordLocator &&
          this.resTodayTrip?.firstName &&
          this.resTodayTrip?.lastName
        ) {
          sessionStorage.setItem(
            'trip_request',
            JSON.stringify({
              recordLocator: this.resTodayTrip.recordLocator,
              firstName: this.resTodayTrip.firstName,
              lastName: this.resTodayTrip.lastName,
              searchType: 'confirmationNo'
            })
          );
          window.location.href = response?.NEXT_GEN_MY_TRIPS_URL
            ? response.NEXT_GEN_MY_TRIPS_URL
            : '/my-trips/trip-details';
        } else {
          window.location.href = response?.NEXT_GEN_MY_TRIPS_URL
            ? response.NEXT_GEN_MY_TRIPS_URL
            : '/my-trips/trip-details';
        }
      } else {
        this.flyoutTodayMytripsForm.nativeElement.action =
          this.formActionflight;
        this.flyoutTodayMytripsForm.nativeElement.submit();
      }
    });
  }

  getMedallionLabelFromContent(memberShipLevel) {
    let medallionLabel = '';
    if (
      this.medallionArrayFromContent !== undefined &&
      this.medallionArrayFromContent !== null
    ) {
      for (let i = 0; i < this.medallionArrayFromContent.length; i++) {
        if (this.medallionArrayFromContent[i].medallionId === memberShipLevel) {
          medallionLabel = this.medallionArrayFromContent[i].medallionLabel;
        }
      }
    }
    return medallionLabel;
  }

  getIROPColorChange(errorCode: String) {
    if (['IRPC_PROT', 'IRPC_NO PROT'].includes(errorCode?.toUpperCase())) {
      this.hideIROPClose = true;
    }

    const codes = {
      IRP_CLEAN_PAX: 'flight-status-green',
      IRPC_CLEAN_AUTO: 'flight-status-green',
      'IRPD_NO PROT_NO MISCONNECT': 'flight-status-orange',
      'IRPD_NO PROT_MISCONNECT': 'flight-status-orange',
      IRPD_PROT: 'flight-status-orange',
      IRPD_CLEAN_AUTO: 'flight-status-orange',
      IRPC_PROT: 'flight-status-red',
      'IRPC_NO PROT': 'flight-status-red',
      IROP_EXC: 'flight-status-red',
      IROP_EXC_STN: 'flight-status-red'
    };

    const bgClass = codes[errorCode?.toUpperCase()] ?? 'flight-status-green';

    return { [bgClass]: true };
  }

  getStatusColorChange(colorCode: String) {
    if (!colorCode) {
      return;
    }
    const colorCodes = {
      GREEN: 'flight-status-green',
      ORANGE: 'flight-status-orange',
      YELLOW: 'flight-status-orange',
      RED: 'flight-status-red'
    };
    const bgClass =
      colorCodes[colorCode?.toUpperCase()] ?? 'flight-status-green';

    return { [bgClass]: true };
  }

  getClassNames(medFlag: string) {
    if (!medFlag) {
      return;
    }

    const flags = {
      GM: 'account-summary-gm',
      DM: 'account-summary-dm',
      PM: 'account-summary-pm',
      FF: 'account-summary-rm',
      FO: 'account-summary-sm'
    };
    const bgClass = flags[medFlag?.toUpperCase()] ?? 'account-summary-sky-mem';

    return { [bgClass]: true };
  }

  removeMargin() {
    setTimeout(() => {
      const errorContainer = document.querySelector(
        '.tab-container .tab-content'
      );
      if (errorContainer) {
        errorContainer.classList.add('m-0');
      }
    }, 300);
  }

  close() {
    this.bsModalRef.hide();
    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
  }

  tripNavItem(selectedItem) {
    this.bsModalRef.hide();
    // For IE Browser dispatchEvent issue KEY-402 START
    // typeof(Event) === 'function' returning FALSE in IE and TRUE in Chrome & Firefox
    let eventTrigger;
    if (typeof Event === 'function') {
      eventTrigger = new Event('click');
    } else {
      eventTrigger = document.createEvent('Event');
      eventTrigger.initEvent('click', true, true);
    }
    // For IE Browser dispatchEvent issue KEY-402 END
    if (selectedItem === 'book') {
      let headerLabel = this.bookingHeaderContentLabel.replace(/\s+/g, '');
      headerLabel = headerLabel.toLowerCase();
      const bookTrip = document.querySelector(
        '#headerLinksContainer ul.nav-primary li a.nav-link-' + headerLabel
      );
      // bookTrip.dispatchEvent(new Event('click')); //Commented or IE Browser dispatchEvent issue KEY-402
      bookTrip.dispatchEvent(eventTrigger);
      this.cdf.detectChanges();
    } else {
      let headerLabel = this.mytripHeaderContentLabel.replace(/\s+/g, '');
      headerLabel = headerLabel.toLowerCase();
      const myTrip = document.querySelector(
        '#headerLinksContainer ul.nav-primary li a.nav-link-' + headerLabel
      );
      // myTrip.dispatchEvent(new Event('click')); //Commented or IE Browser dispatchEvent issue KEY-402
      myTrip.dispatchEvent(eventTrigger);
      this.cdf.detectChanges();
    }
  }

  closeIropModel() {
    this.showIropModel = false;
    /*if (this.flyoutsection) {
      this.flyoutsection.nativeElement.focus();
    }*/
    this._el.nativeElement.querySelector('.flyout-close').focus();
  }

  focusOutFunctionAx(event) {
    const lastfocusElement =
      this._el.nativeElement.parentElement.parentElement.parentElement.querySelector(
        '.nav-tabs .mydelta-tab-link .nav-link'
      );
    lastfocusElement.focus();
    event.preventDefault();
  }

  checkIn(): void {
    if (this.resTodayTripContent.redirectNewCheckIn === 'true') {
      const checkInData = {
        checkinConfirmationNumber: this.resTodayTrip?.recordLocator,
        checkinLastName: this.resTodayTrip?.lastName,
        checkinDepartureAirport: this.resTodayTrip?.departureCityCode,
        checkinSearchType: 'confirmationInput',
        deepLinkFlow: 'true'
      };

      Object.entries(checkInData).forEach(([key, value]) =>
        sessionStorage.setItem(key, value)
      );
      window.location.href = this.checkInSubmitNewUrl;
    } else {
      window.location.href = `${this.hrefURL}${this.resTodayTrip.checkinLink}`;
    }
  }

  ngOnDestroy() {
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    if (this.todayTripServiceTripDetailsSubscribe) {
      this.todayTripServiceTripDetailsSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }
}
